import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSelectedRelated } from '../../../actions'
import './RelatedFunds.css'
import i18n from '../../../i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPlusCircle)

class RelatedFunds extends Component {
  selectFund(fund) {
    this.props.setSelectedRelated(true)
    this.props.action(fund)
  }

  getOverlap(fund) {
    if (fund.overlaps) {
      return `${Math.round(fund.overlaps.values[0] * 100)}%`
    } else {
      return ''
    }
  }

  getCorrelation(fund) {
    if (fund.correlations) {
      return `${fund.correlations.values[0].toFixed(2)}`
    } else {
      return ''
    }
  }

  renderRows(funds) {
    return funds.map(fund => {
      return (
        <tr key={fund.externalID}>
          <td onClick={() => this.selectFund(fund)} className='tickerLink textLeft'>
            <FontAwesomeIcon style={{ color: '#0FACE7' }} size='2x' icon='plus-circle' />
          </td>
          <td onClick={() => this.selectFund(fund)} className='tickerLink textLeft'>
            {fund.ticker}
          </td>
          <td className='textLeft'>{fund.name}</td>
          {fund.overlaps && <td className='textCenter'>{this.getOverlap(fund)}</td>}
          {fund.correlations && <td className='textCenter'>{this.getCorrelation(fund)}</td>}
        </tr>
      )
    })
  }

  render() {
    const { relatedFunds } = this.props

    if (relatedFunds.length > 0) {
      return (
        <React.Fragment>
          <div className='fund-char-related-funds row'>
            <div className='selectCopy col-lg-12 col-sm-12 col-sm-12'>{i18n.t('related-funds')}:</div>
          </div>
          <div className='fund-char-related-funds row'>
            <div className={'col-lg-12 col-sm-12 col-sm-12'}>
              <table className='table tableFC'>
                <thead>
                  <tr>
                    <th colSpan='3'>&nbsp;</th>
                    {relatedFunds[0].overlaps && (
                      <th className='textCenterHeader'>
                        Holdings Overlap
                        <br />
                        with {relatedFunds[0].overlaps.keys[0]}
                      </th>
                    )}
                    {relatedFunds[0].correlations && (
                      <th className='textCenterHeader'>
                        Performance Correlation
                        <br />
                        with {relatedFunds[0].correlations.keys[0]}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>{this.renderRows(relatedFunds)}</tbody>
              </table>
            </div>
          </div>
          <div className='fund-char-related-funds row'>
            <div className='compTxt col-lg-10 col-sm-6 col-sm-12'>
              {i18n.t('related-funds-comp')}
              <br />
              <br />
              Correlation: Statistical measure of how two sets of returns move in relation to each other. Correlation coefficients range from -1 to 1. A correlation of 1 means the two subjects of analysis move in lockstep with each other. A correlation of -1 means the two subjects of analysis have moved in exactly the opposite direction.
              <br />
              <br />
              {i18n.t('comp-holdings')}
              <br />
              {i18n.t('comp-prospect')}
              <br />
              {i18n.t('comp-illustrative')}
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    relatedFunds: state.fundData.relatedFunds
  }
}

export default connect(mapStateToProps, {
  setSelectedRelated
})(RelatedFunds)
